<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='结业管理' label2="结业登记" :label3="this.monthtip" url="/cycle/graduate/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Form Body -->
          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="first">
              <div class="form-group m-form__group row">
                <label class="col-xl-2 col-form-label">姓名：</label>
                <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
                  {{form.stuname}}
                </div>
                <label class="col-xl-2 col-form-label">工号：</label>
                <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
                  {{form.stuno}}
                </div>
                <label class="col-xl-2 col-form-label">专业：</label>
                <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
                  {{form.specname}}
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-xl-2 col-form-label">届别：</label>
                <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
                  {{form.stuyear}}
                </div>
                <label class="col-xl-2 col-form-label">类型：</label>
                <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
                  {{form.usertypename}}
                </div>
                <label class="col-xl-2 col-form-label">年限：</label>
                <div class="col-xl-2" style="text-align: left;padding-top: 8px;">
                  {{form.stueduyearname}}
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="轮转情况" name="second">
              <div class="form-group m-form__group row">
                <label class="col-xl-2 col-form-label">轮转详细：</label>
                <div class="col-xl-9">
                  <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
                    <el-table-column prop="CPSecName" label="轮转科室">
                    </el-table-column>
                    <el-table-column prop="Remark" label="轮转月份">
                    </el-table-column>
                    <el-table-column label="轮转时间" width="250">
                      <template slot-scope="scope">
                        {{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="CPTecName" label="带教老师">
                    </el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <span v-if='scope.row.CPStatus == 1'>未入科</span>
                        <span v-if='scope.row.CPStatus == 2' style="color:green;">已入科</span>
                        <span v-if='scope.row.CPStatus == 3' style="color:red;">缺勤</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button @click="ChangeMonth(scope.row)" type="text" size="medium" v-if='scope.row.CPStatus == 3 || scope.row.CPStatus == 1'>修改</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-xl-2 col-form-label">合计轮转：</label>
                <div class="col-xl-2" style="padding-top: 8px;">{{CPMonthCount}}个月</div>
                <div class="col-xl-2">
                  <el-button type="primary" icon="el-icon-circle-plus-outline" @click="AddPlan()">新增轮转计划</el-button>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="绩效成绩" name="third">
              <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                <el-table v-loading="loading" :data="cpitableData" stripe style="width: 100%" size="medium">
                  <el-table-column label="绩效考评时间">
                    <template slot-scope="scope">
                      {{scope.row.CPIDate|formatDate}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="CPIDScore" label="得分">
                  </el-table-column>
                  <el-table-column prop="MGMoney" label="奖金">
                  </el-table-column>
                  <el-table-column label="发放状态">
                    <template slot-scope="scope">
                      <span v-bind:style="scope.row.GrantStatus == '发'?'color:green;':'color:red;'">{{scope.row.GrantStatus}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="请假记录" name="fourth">
              <div class="form-group m-form__group row" v-if="this.leaverecord > 0">
                <el-table v-loading="loading" :data="leavetableData" stripe style="width: 100%" size="medium">
                  <el-table-column label="请假开始时间">
                    <template slot-scope="scope">
                      {{scope.row.LeaveBeginDate|formatFullDate}}
                    </template>
                  </el-table-column>
                  <el-table-column label="请假结束时间">
                    <template slot-scope="scope">
                      {{scope.row.LeaveEndDate|formatFullDate}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="LeaveReason" label="请假原因">
                  </el-table-column>
                  <el-table-column prop="LeaveDay" label="请假天数">
                  </el-table-column>
                </el-table>
              </div>
              <div class="form-group m-form__group row" v-if="this.leaverecord > 0">
                <label class="col-xl-2 col-form-label">合计请假数：</label>
                <div class="col-xl-9" style="padding-top: 8px;">{{LeaveDayCount}}天</div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label" style="padding-top: 15px;">状态：</label>
            <div class="col-xl-3 col-lg-3" style="text-align: left;">
              <el-form-item prop="stueditstatus" :rules="{required: true, message: '状态不能为空', trigger: 'blur'}">
                <el-radio-group v-model="form.stueditstatus">
                  <el-radio :label="5" border>已结业</el-radio>
                  <el-radio :label="4" border>延期</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label" style="padding-top: 13px;">延期天数：</label>
            <div class="col-xl-2">
              <el-form-item prop="studelay" :rules="{required: true, message: '延期天数不能为空', trigger: 'blur'}">
                <el-input v-model="form.studelay"></el-input>
              </el-form-item>
            </div>
            <!-- <div class="col-xl-2" v-if="this.form.stueditstatus == 4">
              <el-button type="primary" icon="el-icon-circle-plus-outline" @click="AddPlan()">新增轮转计划</el-button>
            </div> -->
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid" style="background-color: #FFFFFF;">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <SaveButton :url='saveUrl' back="/cycle/graduate/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <el-dialog width="30%" title="修改轮转计划" :visible.sync="planVisible">
        <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="planform"
          ref="planform">
          <div class="m-portlet__body">
            <div class="form-group m-form__group row">
              <label class="col-xl-4 col-form-label">轮转科室：</label>
              <div class="col-xl-6">
                <el-form-item prop="cpsec" :rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
                  <el-select v-model="planform.cpsec" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-xl-4 col-form-label">开始时间：</label>
              <div class="col-xl-6">
                <el-form-item prop="cpbegindate" :rules="{required: true, message: '开始时间不能为空', trigger: 'blur'}">
                  <el-date-picker v-model="planform.cpbegindate" type="date" placeholder="计划开始时间" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-xl-4 col-form-label">结束时间：</label>
              <div class="col-xl-6">
                <el-form-item prop="cpenddate" :rules="{required: true, message: '结束时间不能为空', trigger: 'blur'}">
                  <el-date-picker v-model="planform.cpenddate" type="date" placeholder="计划结束时间" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <div class="col-xl-12 m--align-center">
                <el-button type="success" icon="el-icon-s-order" @click="SavePlan()">保存</el-button>
              </div>
            </div>
          </div>
        </el-form>
      </el-dialog>
      <el-dialog width="30%" title="添加轮转计划" :visible.sync="planAddVisible">
        <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="planform"
          ref="planform">
          <div class="m-portlet__body">
            <div class="form-group m-form__group row">
              <label class="col-xl-4 col-form-label">轮转科室：</label>
              <div class="col-xl-6">
                <el-form-item prop="cpsec" :rules="{required: true, message: '轮转科室不能为空', trigger: 'blur'}">
                  <el-select v-model="planform.cpsec" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-xl-4 col-form-label">开始时间：</label>
              <div class="col-xl-6">
                <el-form-item prop="cpbegindate" :rules="{required: true, message: '开始时间不能为空', trigger: 'blur'}">
                  <el-date-picker v-model="planform.cpbegindate" type="date" placeholder="计划开始时间" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-xl-4 col-form-label">结束时间：</label>
              <div class="col-xl-6">
                <el-form-item prop="cpenddate" :rules="{required: true, message: '结束时间不能为空', trigger: 'blur'}">
                  <el-date-picker v-model="planform.cpenddate" type="date" placeholder="计划结束时间" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <div class="col-xl-12 m--align-center">
                <el-button type="success" icon="el-icon-s-order" @click="PlanAdd()">新增</el-button>
              </div>
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Graduate',
    data() {
      return {
        form: {
          id: '',
          stuname: '',
          stuno: '',
          specname: '',
          stuyear: '',
          usertypename: '',
          stueduyearname: '',
          stueditstatus: '',
          studelay: '',
          token: '',
          plantable: []
        },
        planform: {
          id: '',
          cpstuid: '',
          cpstuname: '',
          cpstuno: '',
          cpsec: '',
          cpbegindate: '',
          cpenddate: '',
          cpstatus: '',
          token: '',
          cpoldbegindate: '',
          cpoldenddate: ''
        },
        activeName: 'first',
        planSectionName: '',
        planids: '',
        planVisible: false,
        planAddVisible: false,
        username: '',
        rolelevel: '',
        secid: '',
        tableData: null,
        cpitableData: null,
        leavetableData: null,
        leaverecord: 0,
        saveUrl: this.$utils.Url.zpgl + '/api/APIStu/Update',
        loading: true,
        CPMonthCount: '0',
        LeaveDayCount: '0',
        monthtip: '',
        secOptions: []
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      },
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      SetDictName: function(data) {
        this.planSectionName = data
      },
      LoadGraduateInfo: function() {
        var that = this
        var args = {
          id: this.form.id,
          token: this.form.token
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/GraduateInfo', args, function(data, model) {
          model.stuname = data.Data.StuName
          model.stuno = data.Data.StuNo
          that.planform.cpstuid = data.Data.CPStuID
          that.planform.cpstuname = data.Data.StuName
          that.planform.cpstuno = data.Data.StuNo
          model.specname = data.Data.SpecName
          model.stuyear = data.Data.StuYearName
          model.usertypename = data.Data.UserTypeName
          model.stueduyearname = data.Data.StuEduYearName
          if (data.Data.StuEditStatus != 4 && data.Data.StuEditStatus != 5) {
            model.stueditstatus = 5
          } else {
            model.stueditstatus = data.Data.StuEditStatus
          }
          if (data.Data.StuDelay === null) {
            model.studelay = data.Data.LeaveDayCount
          } else {
            model.studelay = data.Data.StuDelay
          }
        }, null, null, this.form)
      },
      LoadCP: function() {
        var cpargs = {
          username: this.username,
          rolelevel: this.rolelevel,
          secid: this.secid,
          cpstuid: this.form.id,
          token: this.form.token,
          order: 'CPBeginDate',
          pageSize: 99999,
          currentPage: 1
        }
        this.loading = true
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/CPInfo', cpargs)
          .then(res => {
            if (res.data.Code === 0) {
              this.CPMonthCount = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.CPMonthCount = '0'
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      LoadCPList: function() {
        var cpargs = {
          username: this.username,
          rolelevel: this.rolelevel,
          secid: this.secid,
          cpstuid: this.form.id,
          token: this.form.token,
          order: 'CPBeginDate',
          pageSize: 99999,
          currentPage: 1
        }
        this.loading = true
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/CPDetailList', cpargs)
          .then(res => {
            if (res.data.Code === 0) {
              this.tableData = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.tableData = null
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      LoadCPIDetail: function() {
        var cpargs = {
          cpitype: '1',
          cpidate: '',
          id: this.form.id,
          name: '',
          token: this.form.token,
          pageSize: 99999,
          currentPage: 1,
          recordCount: 0
        }
        this.loading = true
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ReportScoreCPIList', cpargs)
          .then(res => {
            if (res.data.Code === 0) {
              this.cpitableData = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.cpitableData = null
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      LoadLeave: function() {
        var args = {
          id: this.form.id,
          token: this.form.token,
          pageSize: 99999,
          currentPage: 1,
          recordCount: 0
        }
        this.loading = true
        this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/List', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.leavetableData = res.data.Data
              this.leaverecord = res.data.Pager.RecordCount
              if (this.leaverecord > 0) {
                this.LeaveDayCount = res.data.Data[0]["LeaveDayCount"]
              }
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.leavetableData = null
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      AddPlan: function() {
        this.planAddVisible = true
        this.planform.cpsec = ''
        this.planform.cpbegindate = ''
        this.planform.cpenddate = ''
      },
      PlanAdd: function() {
        var args = {
          token: this.form.token,
          cpstuid: this.planform.cpstuid,
          cpstuname: this.planform.cpstuname,
          cpstuno: this.planform.cpstuno,
          cpsec: this.planform.cpsec,
          cpbegindate: this.planform.cpbegindate,
          cpenddate: this.planform.cpenddate
        }
        this.loading = true
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/Add', args)
          .then(res => {
            if (res.data.Code === 0) {
              that.planAddVisible = false
              this.LoadCPList()
              this.LoadMonthInfo()
              this.LoadCP()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '新增失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      SavePlan: function() {
        var args = {
          token: this.form.token,
          id: this.planform.id,
          secid: this.planform.cpsec,
          cpbegindate: this.planform.cpbegindate,
          cpenddate: this.planform.cpenddate,
          cpstatus: this.planform.cpstatus,
          cpoldbegindate: this.planform.cpoldbegindate,
          cpoldenddate: this.planform.cpoldenddate
        }
        this.loading = true
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/ChangeMonth', args)
          .then(res => {
            if (res.data.Code === 0) {
              that.planVisible = false
              this.tableData = res.data.Data
              this.LoadMonthInfo()
              this.LoadCP()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '保存失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      ChangeMonth: function(row) {
        this.planVisible = true
        this.planform.id = row.ID
        this.planform.cpsec = row.CPSec
        this.planform.cpbegindate = row.CPBeginDate
        this.planform.cpenddate = row.CPEndDate
        this.planform.cpoldbegindate = row.CPBeginDate
        this.planform.cpoldenddate = row.CPEndDate
        this.planform.cpstatus = row.CPStatus
      },
      LoadMonthInfo: function() {
        var args = {
          token: this.form.token,
          stuid: this.form.id
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadStuCPMonthInfo', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.monthtip = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      LoadCPSec: function() {
        var args = {
          token: this.form.token,
          username: this.username,
          rolelevel: this.rolelevel,
          mamagesec: ''
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.planform.token = sessionStorage.getItem('token')
      this.username = sessionStorage.getItem('username')
      this.rolelevel = sessionStorage.getItem('rolelevel')
      this.secid = sessionStorage.getItem('secid')
      this.form.id = this.$route.params.id
      this.LoadMonthInfo()
      this.LoadGraduateInfo()
      this.LoadCPList()
      this.LoadCP()
      this.LoadCPIDetail()
      this.LoadLeave()
      this.LoadCPSec()
    }
  }
</script>

<style scoped="scoped">
  .m-form.m-form--group-seperator-dashed .m-form__group {
    border-bottom: 0;
  }
</style>
